import { connect } from 'react-redux'
import Component from 'components/DashboardTemplates/FormView/Metrics'

export default connect()(Component)
